import { useState } from "react";
import { RiSearchLine } from "react-icons/ri";
import { useHistory } from "react-router-dom";
import { PuffLoader } from "react-spinners";
import { artemulkImages, siteName, siteTagline } from "../../../data/artemulkContent";
import HeroBtn from "./HeroBtn";

const heroBackground = artemulkImages.heroBackground;

const Hero = () => {
  const [filter, setFilter] = useState("");
  const history = useHistory();

  const [imageLoaded, setImageLoaded] = useState(false);
  // Resim yüklendiğinde bu işlevi çağırın
  const handleImageLoad = () => {
    setImageLoaded(true);
  };

  const handleSearch = () => {
    // Arama butonuna tıkladığınızda, /adverts yoluna yönlendirme yapılır
    history.push(`/adverts?search=${filter}`);
  };
  
  const handleEnterKeyPress = (e) => {
    // Enter tuşuna basıldığında handleSearchClick çalıştırılacak
    if (e.key === "Enter") {
      handleSearch();
    }
  };
  const buttons = [
    { title: "TÜM İLANLAR", underline: "bg-[#FFFFFF]", to:"/adverts"},
    { title: "SATILIK", to:"/sale"},
    { title: "KİRALIK",to:"/rent" },
    { title: "KONUT", to:"/house" },
    { title: "ARSA" , to:"/land"  },
    { title: "İŞ YERİ", to:"/workplace" },
    { title: "TURİSTİK" , to:"/touristy" }
    
  ];
  return (
    <>
 
   {!imageLoaded ? (<div className="h-[25rem] sm:h-[27rem] flex ">
       <div className="absolute  w-full      ">
             <div className=" absolute w-full h-[25rem]  "></div>

             <div className="wrapper flexCenter" >
             <PuffLoader
               height="80"
               width="80"
               radius={1}
               color="#c5955b"
               aria-label="puff-loading"
             />
           </div>
         
             <img
               src={heroBackground}
               className="object-cover w-full  h-[25rem] sm:h-[27rem] hidden"
               onLoad={handleImageLoad}
             />
       </div> 
    
      </div>
         ) : ( <div className="h-[25rem] sm:h-[27rem] flex  ">
       
       <div className="absolute  w-full      ">
         <div className=" absolute w-full h-[25rem]  "></div>
         
         <img
           src={heroBackground}
           className="object-cover w-full  h-[25rem] sm:h-[27rem] "
           onLoad={handleImageLoad}
         />
       </div>
       <div className="relative flex flex-col items-center w-full sm:pb-16 text-center">
         <div className="flex items-center justify-center gap-3 px-2">
          <img
            src={`${process.env.PUBLIC_URL || ""}/artemulk/img/logo-mark.png?v=favv`}
            alt=""
            aria-hidden
            className="h-9 w-auto sm:h-14 brightness-0 invert"
          />
          <p className="text-white text-[28px] sm:text-[48px] font-bold [text-shadow:_0_1px_0_rgb(0_0_0_/_40%)]">
            {siteName}
          </p>
        </div>
         <p className="text-white px-2 pt-2 sm:pt-0 sm:text-[23px] [text-shadow:_0_1px_0_rgb(0_0_0_/_40%)]">
         {siteTagline}
         </p>
         <ul className="">
         <div className="pt-8 flex flex-wrap justify-center gap-x-2 gap-y-2 text-center items-center max-w-full px-2">
           {buttons.map((button, index) => (
             <HeroBtn
               key={index}
               to={button.to}
               title={button.title}
               underline={button.underline}
               css={button.css}
             />
           ))}
         </div>
         
         </ul>
         {/* Input */}
         <div className="relative mt-9 mx-4 sm:mx-0"> {/* 'mx-4' ekledik */}
          <input
            type="search"
            className="bg-white py-4 w-full sm:w-[37rem] rounded-full pl-5 placeholder:text-gray-500 placeholder:text-[11px] sm:placeholder:text-[14px]  outline-0"
            placeholder="Adres, Şehir, Mahalle, İlan Ara.."
            value={filter}
            onChange={(e) => setFilter(e.target.value)}
            onKeyDown={handleEnterKeyPress}
 
          />
          <div className="absolute w-[2.7rem] h-[2.7rem] rounded-full bg-[#2B2B2B] top-[0.4rem] right-1 flex items-center justify-center">
            <button type="button" className="hero-icon-btn" onClick={handleSearch} aria-label="Ara">
              <RiSearchLine className="text-white text-[22px]" />
            </button>
          </div>
        </div>
 
       </div>
     </div>)
     }
    
    </>
    
  );
};

export default Hero;
